import React from 'react'

export const loadScripts = () => {
	// const scriptA = document.createElement('script')
	// scriptA.src = '/assets/js/pages/dashboard.init.js'
	// // scriptA.async = true
	// scriptA.id = 'scriptA'
	// document.body.appendChild(scriptA)

	const scriptB = document.createElement('script')
	scriptB.src = '/assets/js/app.min.js'
	// scriptB.async = true
	scriptB.id = 'scriptB'
	document.body.appendChild(scriptB)

	const scriptC = document.createElement('script')
	scriptC.src = '/assets/js/anime.min.js'
	// scriptB.async = true
	scriptC.id = 'scriptC'
	document.body.appendChild(scriptC)
}

export const removeScripts = () => {
	// remove existing
	// document.getElementById('scriptA').remove()
	document.getElementById('scriptB').remove()
	document.getElementById('scriptC').remove()
}
